module.exports = __webpack_public_path__ + "img/a685_halo.fb72aeef.png";